<div class="collapse-wrapper" [ngClass]="'headerLayout-' + headerLayout()">
    <!-- Default layout (non-layout-12) -->
    @if (!isLayout12()) {
    <div class="title-section" (click)="selectCategory$.emit(sub_category()?.id); $event.stopPropagation()">
        <a (click)="hideMenu$.emit(true); $event.stopPropagation()" class="mobile-category-menu dynamic-desktop-hamburger-panel-text-color border-style" [routerLink]="'category/' + sub_category()?.url_path"><label>{{ sub_category()?.name }} </label></a>
        <img [ngClass]="!actualCollapsed() ? 'arrow-up' : 'arrow-down'" [src]="menuCollapseIcon()" class="down-arrow-icon" />
    </div>
    }

    <!-- Layout-12 specific HTML -->
    @if (isLayout12()) {
    <div class="title-section layout-12-specific">
        <div class="menu-item-content menu-item-main-container">
            <div class="menu-item-image-text-wrapper menu-item-image-anchor-container">
                <div class="combine-wrapper">
                    <div class="menu-icon menu-item-image-container">
                        <img [id]="sub_category()?.id" [src]="sub_category()?.category_images?.[0] || IMAGE_URLS.productEmptyState" class="category-image menu-item-category-image" />
                    </div>

                    <a (click)="hideMenu$.emit(true); $event.stopPropagation()" class="mobile-category-menu static-header layout-12-menu" [id]="sub_category()?.id" [routerLink]="'category/' + sub_category()?.url_path">
                        {{ sub_category()?.name }}
                    </a>
                </div>
            </div>
            <img [ngClass]="!actualCollapsed() ? 'arrow-up' : 'arrow-down'" [src]="menuCollapseIcon()" class="down-arrow-icon header-menu-collapse" (click)="selectCategory$.emit(sub_category()?.id); $event.stopPropagation()" />
        </div>
    </div>
    }

    <div [@collapse]="actualCollapsed().toString()">
        <ng-content></ng-content>
    </div>
</div>